import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { createHistoryMessageCuentasCobrar, getDocumentsByCuentasCobrarId, getHistorialCuentasCobrar, getNotesByOrdenCobroId, getUsersRoleCob, insertNoteCuentasCobrar, obtenerCamposFiltroCobro, obtenerCuentasPorEtapa, obtenerDatosFiltrosCobro, obtenerOrdenPorID, serviceEditarOrdenCobro } from '../../../../service/cuentas_cobrar/CuentasCobrar';
import { GenericoModel } from '../../../catalogos/generico/models/GenericoModel';
import { CuentasCobrarModel, DocumentoCuentasCobrarModel, NotaCuentasCobrarModel } from '../models/CuentasCobrarModel';
import { SimpleAlert } from '../../../../../_metronic/helpers';
import { HistoryModel } from '../../../contacto/models/HistoryModel';
import { SelectFormat } from '../../../../../_metronic/helpers/models/GenericModel';

export const useObtenerCuentasPorEtapa = (actualizarCuentas: number, initFilterValues: any) => {
  const [cuentas, setCuentas] = useState<any[]>([]);
  const [cuentasPorEtapa, setCuentasPorEtapa] = useState<any[]>([]);
  const [cargandoCuentas, setCargandoCuentas] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    let isMounted = true; 
    const fetchTareas = async () => {
      setCargandoCuentas(true);
      try {
        const res = await obtenerCuentasPorEtapa(initFilterValues);
        if (res && isMounted) {
          setCuentas(res.cuentas);
          setCuentasPorEtapa(res.cuentasPorEtapa);
        }
      } catch (error) {
        if (isMounted) {
          history.push('/error/500');
        }
      } finally {
        if (isMounted) {
          setCargandoCuentas(false);
        }
      }
    };
    
      fetchTareas();
    
    return () => {
      isMounted = false;
    };
  }, [actualizarCuentas, history]);

  return { cuentas, cuentasPorEtapa, cargandoCuentas };
};


export const useObtenerCamposFiltroCobro = (isAdmin: any) => {
  const [listFields, setListFields] = useState<GenericoModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);

  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      setLoadingRequest(true);
      try {
        const res = await obtenerCamposFiltroCobro();
        if (isMounted && res) {
          let filteredRes = res;
          filteredRes = res.filter((option: any) => option.code !== "ORD_COB_FECHA_VENC" && option.code !== "ORD_COB_FECHA_FAC" && option.code !== "ORD_COB_FOLIO");

          if (!isAdmin) {
            filteredRes = res.filter((option: any) => option.code !== "ORD_COB_USER");
          }
          const selectOptions = filteredRes.map((option: any) => ({
            value: option.id,
            label: `${option.name}`,
            code: option.code,
          }));
          setListFields(selectOptions);
        }
      } catch (error) {
        history.push("/error/500");
      } finally {
        if (isMounted) {
          setLoadingRequest(false);
        }
      }
    };
    fetchPost();
    return () => {
      isMounted = false;
    };
  }, [history, isAdmin]);

  return {
    listFields,
    loadingRequest,
  };
};



export const useObtenerDatosFiltrosCobro = (code: string) => {
  const [dataOptionSelected, setDataOptionSelected] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);

  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      setLoadingRequest(true);
      try {
        const res = await obtenerDatosFiltrosCobro(code);
        if (isMounted && res) {
          setDataOptionSelected(res);
        }
      } catch (error) {
        history.push("/error/500");
      } finally {
        if (isMounted) {
          setLoadingRequest(false);
        }
      }
    };

    if (code) {
      fetchPost();
    }

    return () => {
      isMounted = false;
    };
  }, [code, history]);

  return {
    dataOptionSelected,
    loadingRequest,
  };
};



export const useObtenerOrdenPorID = (id: number) => {
  const initialCuentasCobrar: CuentasCobrarModel = {
      id: 0,
      nombre: '',
      telefono: '',
      email: '',
      concepto_cobro: '',
      no_cobro: 0,
      cobro: '0.00',
      folio: '',
      fecha_facturacion: '',
      fecha_vencimiento: '',
      created_at: '',
      tipoProyecto: {
        id: 0,
        name: '',
        code: '',
      },
      unidadMoneda: {
        id: 0,
        name: '',
        code: '',
      },
      cuenta: {
        id: 0,
        nombre: '',
      },
      subcuenta: null,
      vendedorAsignado: {
        id: 0,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        telefono: '',
        user: {
          id: 0,
          profile_photo: '',
        },
      },
      cobrador: {
        id: 0,
        first_name: '',
        father_last_name: '',
        mother_last_name: '',
        profile_photo: '',
      },
      contacto: {
        id: 0,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        telefono: '',
      },
      tipoPago: {
        id: 0,
        name: '',
        code: '',
      },
      etapa: {
        id: 0,
        name: '',
        code: '',
      },
      estatus: {
        id: 0,
        name: '',
        code: '',
      },
      cotizacion: {
          id: 0,
          folio: ""
      },
      formaPago:{
        id: 0,
        dias_pago: 0
      },
      proyecto:{
        id: 0,
        nombre: ''
      }
    };
  

  const [ordenCobro, setOrdenCobro] = useState<any>(initialCuentasCobrar);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(true);
      await obtenerOrdenPorID(id)
        .then((res) => {
          if (res) {
            setOrdenCobro(res);
            setLoadingRequest(false);
          }
        })
        .catch((error) => {
          history.push('/error/500');
        });
    };
    if (id > 0) {
      fetchPost();
    } else {
      setOrdenCobro(initialCuentasCobrar);
      setLoadingRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { ordenCobro, loadingRequest };
};



export const useEditarOrdenCobro = () => {
  const history = useHistory();
  const [successRequest, setSuccessRequest] = useState<boolean>(false);
  const editarOrdenCobro = async (values: CuentasCobrarModel) => {
    setSuccessRequest(false);
    try {
      const res = await serviceEditarOrdenCobro(values);
      setSuccessRequest(true);
      SimpleAlert(res.data.message, 3000, 'success');
      history.goBack();
    } catch (error: any) {
      if (error && error.response) {
        const { message } = error.response.data;
        SimpleAlert(message, 3000, 'error');
        setSuccessRequest(true);
      } else {
        history.push('/error/500');
      }
    }
  };
  return { editarOrdenCobro, successRequest };
};

export const useGetNoteByOrdenCobroId = (id: number, reaload: number) => {
  const [notes, setNotes] = useState<NotaCuentasCobrarModel[]>([]);
  const [loadingNote, setLoadingNote] = useState<boolean>(false);

  const history = useHistory();
  useEffect(() => {
    setLoadingNote(false);
    const fetchPost = async () => {
      try {
        const res = await getNotesByOrdenCobroId(id);
        if (res) {
          setNotes(res);
          setLoadingNote(true);
        }
      } catch (error) {
        history.push("/error/500");
        setLoadingNote(false);
      }
    };
    if (id) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, reaload]);

  return { notes, loadingNote };
};

export const useCreateNoteCuentasCobrar = () => {
  const [loadingCreateNote, setLoadingCreateNote] = useState<boolean>(false);
  const history = useHistory();
  const createNote = async (note: NotaCuentasCobrarModel, id: number) => {
    setLoadingCreateNote(false);
    try {
      const res = await insertNoteCuentasCobrar(note, id);
      SimpleAlert(res.message, 3000, 'success');
      setLoadingCreateNote(true);
    } catch (error: any) {
      setLoadingCreateNote(false);
      if (error && error.response) {
        const { message } = error.response.data;
        SimpleAlert(message, 3000, 'error');
      } else {
        history.push('/error/500');
      }
    }
    
  };
  return { createNote, loadingCreateNote };
};


export const useGetDocumentsByCuentasCobrarId = (
  cuentasCobrarId: number,
  reload: number
) => {
  const [dataDocuments, setDataDocuments] = useState<DocumentoCuentasCobrarModel[]>([]);
  const [loadingDocuments, setLoadingDocuments] = useState<boolean>(false);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingDocuments(false);
      const res = await getDocumentsByCuentasCobrarId(cuentasCobrarId)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setDataDocuments(res);
        setLoadingDocuments(true);
      }
    };
    if (cuentasCobrarId > 0) {
      fetchPost();
    }
  }, [reload]);

  return { dataDocuments, loadingDocuments };
};

export const useGetHistoryCuentasCobrar = (reaload: number, search: string, id: string) => {
  const [data, setData] = useState<HistoryModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(0);
      const res = await getHistorialCuentasCobrar(search, id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setData(res);
        setLoadingRequest(1);
      }
    };
    if (reaload && Number(id) > 0) {
      fetchPost();
    }
  }, [reaload]);

  return { data, loadingRequest };
};

export const useInsertMessageCuentasCobrar = () => {
  const [loadingInsert, setLoadingInsert] = useState<boolean>(false);
  const history = useHistory();
  const insertData = async (message: string, id: number) => {
    setLoadingInsert(false);
    try {
      await createHistoryMessageCuentasCobrar(message, id);
      setLoadingInsert(true);
    } catch (error) {
      history.push("/error/500");
      setLoadingInsert(false);
    }
  };
  return { insertData, loadingInsert };
};


export const useGetUsersCob = () => {
  const [dataSelect, setDataSelect] = useState<SelectFormat[]>([]);
  const [loadingSelect, setLoadingSelect] = useState<boolean>(false);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingSelect(false);
      const res = await getUsersRoleCob()
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setDataSelect(res);
        setLoadingSelect(true);
      }
    };
    fetchPost();
  }, []);

  return { dataSelect, loadingSelect };
};